/**
 * OwalListItem.js
 *
 * @description A model object for list items.
 */

/**
 * A model object for list items.
 *
 * @prop {String} identifier The identifier to use to identify the item.
 * @prop {String} title The title to display in the list row.
 * @prop {String} subtitle Optional. A subtitle title to display in the list row.
 * @prop {Object} userInfo Optional. An object containing custom information.
 *
 * @export
 * @class OwalListItem
 */
export class OwalListItem {
  constructor ({ identifier, title, subtitle, userInfo } = {}) {
    this.identifier = identifier
    this.title = title
    this.subtitle = subtitle
    this.userInfo = userInfo
  }
}
